module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"searchProperty":"Chercher une propiété","createProperty":"Créer une propriété","town":"Commune","street":"Rue","streetNumber":"Numéro de police","noPropertiesFound":"Aucune propriété trouvé","Properties":"Propriétés","properties":"propriétés","loading":"Chargement...","folderNumber":"N° dossier","filter":"Filtrer","compliance_investigation_only":"Enquête de conformité seule"}}')
  delete Component.options._Ctor
}
